<template>
    <div class="carousel">
        <div class="carousel__list">
            <div
                v-for="(artist, index) in featureArtist"
                :key="index"
                @click="update()"
                :class="carouselClass(index)"
                class="carousel__item"
            >
                <div class="artist-card" :key="index">
                    <div class="artist-media">
                        <div class="artist-img-carousel position-relative">
                            <img class="img" :src="artist.avatar" />
                            <div class="audio-container">
                                <div class="player">
                                    <div
                                        class="js-audios-container"
                                        @mouseenter="onAudioEnter"
                                    >
                                        <div
                                            class="artist-audio custom-audio-element d-flex align-items-center justify-content-evenly"
                                            :data-audio-idx="index"
                                        >
                                            <audio
                                                hidden
                                                class="d-none"
                                                :data-audio-idx="index"
                                            >
                                                <source :src="artist.url" type="audio/mp3" />
                                            </audio>
                                            <div class="position-relative">
                                                <img
                                                    :src="getIcon() + 'play-button-event.png'"
                                                    class="btn-profile-sound js-profile-btn play js-play-audio play-img-btn"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <p class="song-name">
                                            {{ artist.title }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="artist-sample"></div>
                    </div>
                    <div class="artist-info">
                        <div class="artist-name">
                            <div class="artist-name-text">{{ artist.band_name }}</div>
                            <div class="artists-rait">
                                <img class="rait-img" src="/images/Star1.png" alt="" />
                                {{ artist.user.avg_reviewers }}
                            </div>
                        </div>
                        <div class="social-stat">{{ artist.followers }} Followers</div>
                        <div class="artist-location">{{ artist.home_location }}</div>
                        <div class="artist-tags" v-if="artist.keyword">
                            <div
                                v-for="(tag, index) in artist.keyword.split(',')"
                                :key="index"
                                class="tag"
                            >
                                <span class="tag-text">{{ tag }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ArtistCarousel',
        data() {
            return {
                featureArtist: [
                    {
                        id: 0,
                        user_id: 0,
                        band_name: 'Artist Name',
                        title: 'Sample Song Title',
                        avatar: '/images/global/artist1.png',
                        home_location: 'Aurora, Illinois',
                        followers: 2500,
                        keyword: 'Artist Tag 1,Artist Tag 2,Artist Tag 3',
                        user: {
                            avg_reviewers: 4.6
                        }
                    },
                    {
                        id: 1,
                        user_id: 1,
                        band_name: 'Artist Name',
                        title: 'Sample Song Title',
                        avatar: '/images/global/artist2.png',
                        home_location: 'Aurora, Illinois',
                        followers: 2500,
                        keyword: 'Artist Tag 1,Artist Tag 2,Artist Tag 3',
                        user: {
                            avg_reviewers: 4.6
                        }
                    },
                    {
                        id: 2,
                        user_id: 2,
                        band_name: 'Artist Name',
                        title: 'Sample Song Title',
                        avatar: '/images/global/artist3.png',
                        home_location: 'Aurora, Illinois',
                        followers: 2500,
                        keyword: 'Artist Tag 1,Artist Tag 2,Artist Tag 3',
                        user: {
                            avg_reviewers: 4.6
                        }
                    }
                ],
                activeIndex: 0
            }
        },
        methods: {
            update() {
                if (this.activeIndex === 0) {
                    this.activeIndex = this.featureArtist.length - 1
                } else {
                    this.activeIndex = this.activeIndex - 1
                }
            },
            isCurrentCard(indx) {
                return indx === this.activeIndex
            },
            isNextCard(indx) {
                let currentArtistLen = this.featureArtist.length

                if (indx === this.activeIndex + 1) return true
                if (this.activeIndex === currentArtistLen - 1 && indx === 0) return true
            },
            isPrevCard(indx) {
                let currentArtistLen = this.featureArtist.length

                if (indx === this.activeIndex - 1) return true
                if (indx === currentArtistLen - 1 && this.activeIndex === 0) return true
            },
            isHiddenCard(indx) {
                let currentArtistLen = this.featureArtist.length

                if (currentArtistLen <= 3) return false

                if (this.isNextCard(indx) || this.isPrevCard(indx) || this.isCurrentCard(indx))
                    return false
                return true
            },
            onAudioEnter() {
                window.__initAudioElements()
                window.__pauseOtherAudios()
            },
            getIcon() {
                return '/images/'
            }
        },
        computed: {
            carouselClass: (self) => (indx) => {
                if (self.isHiddenCard(indx)) return { 'hidden-card': true }
                if (self.isPrevCard(indx)) return { 'prev-card': true }
                if (self.isCurrentCard(indx)) return { 'curr-card': true }
                if (self.isNextCard(indx)) return { 'next-card': true }
            }
        }
    }
</script>

<style lang="css" scoped>
    .custom-audio-element {
        margin-bottom: 15px;
    }
    .play-img-btn {
        min-width: 30px;
        min-height: 30px;
        cursor: pointer;
    }
    .audio-container {
        position: absolute;
        bottom: 0;
        left: 45px;
    }
    .player {
        display: flex;
        align-items: baseline;
        gap: 6px;
    }
    .song-name {
        color: #f5f5f5;
        font-family: Instrument Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        white-space: nowrap;
        max-width: 85%;
        margin: 0;
    }
    .tag-text {
        color: #8b8b8b;
        font-family: Instrument Sans;
        font-size: 12px;
        font-style: normal;
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
    }
    .tag {
        border-radius: 100px;
        border: 1px solid #8b8b8b;
        min-width: 93px;
        padding: 3px 10px 4px 10px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .artist-tags {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 5px;
        margin-top: 10px;
    }
    .artist-location {
        color: #646464;
        font-family: Instrument Sans;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.14px;
        padding-top: 5px;
    }
    .social-stat {
        color: #acacac;
        font-family: Instrument Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        padding-top: 5px;
    }
    .rait-img {
        max-height: 18px;
        max-width: 18px;
        margin-right: 6px;
    }
    .artist-name {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
    .artists-rait {
        color: #acacac;
        font-family: Instrument Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .artist-name-text {
        color: #acacac;
        font-family: Instrument Sans;
        font-size: 26px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.52px;
    }
    .artist-info {
        display: flex;
        flex-direction: column;
        padding: 20px;
        background: #262626;
        border-radius: 0 0px 15px 15px;
    }
    .img {
        border-radius: 15px 15px 0 0;
        max-height: 250px;
        min-width: 330px;
        object-fit: cover;
    }
    .artist-media {
        display: flex;
        align-items: center;
        flex-direction: column;
    }
    .artist-card {
        display: flex;
        flex-direction: column;
        min-width: 310px;
        box-shadow: 0px 0px 100px 60px black;
    }
    .carousel {
        display: flex;
    }
    .carousel__list {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .carousel__item {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 12px;
        position: absolute;
        transition: all 0.3s ease-in;
    }

    .prev-card {
        order: 1;
        z-index: 0;
        transform: translateX(50%) scale(0.8);
    }
    .curr-card {
        order: 2;
        z-index: 2;
    }
    .next-card {
        order: 3;
        z-index: 1;
        transform: translateX(-50%) scale(0.8);
    }
    .hidden-card {
        display: none;
    }

    @media (max-width: 600px) {
        .prev-card {
            transform: translateX(20%) scale(0.8);
        }
    }
</style>
